import { PersonAddOutlined, PersonRemoveOutlined } from "@mui/icons-material";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { setFriends } from "state";
import FlexBetween from "./FlexBetween";
import UserImage from "./UserImage";
import { useNavigate } from "react-router-dom";

const Friend = ({ friendId, name, subtitle, userPicturePath }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { _id } = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const friends = useSelector((state) => state.user.friends);
  
  // colors
  const { palette } = useTheme();
  const primaryLight = palette.primary.light;
  const primarDark = palette.primary.dark;
  const main = palette.neutral.main;
  const medium = palette.neutral.medium;

  // console.log(useSelector((state) => state.user));
  
  const isFriend = friends.find((friend) => friend._id === friendId); //whether friend or not

  //   API call to add and remove the friend
  const patchFriend = async () => {
    console.log("patch frien called");
    const response = await fetch(
      `http://localhost:3001/users/${_id}/${friendId}`,
      {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();
    dispatch(setFriends({ friends: data }));
  };
  return (
    <FlexBetween>
      <FlexBetween gap={"1rem"}>
        <UserImage image={userPicturePath} size="55px" />
        <Box
          onClick={() => {
            navigate(`/profile/${friendId}`);
            //   refresh the page its just the workaround because the route updates but the component does not render
            navigate(0);
          }}
        >
          <Typography
            color={main}
            variant="h5"
            fontWeight={500}
            sx={{
              "&:hover": { color: primaryLight, cursor: "pointer" },
            }}
          >
            {name}
          </Typography>
          <Typography color={medium} fontSize={"0.75rem"}>
            {subtitle}
          </Typography>
        </Box>
      </FlexBetween>

      <IconButton
        onClick={() => {
          patchFriend();
        }}
        sx={{ backgroundColor: primaryLight, p: "0.6rem" }}
      >
        {isFriend ? (
          <PersonRemoveOutlined sx={{ color: primarDark }} />
        ) : (
          <PersonAddOutlined sx={{ color: primarDark }} />
        )}
      </IconButton>
    </FlexBetween>
  );
};
export default Friend;
